import axios from '@/plugins/axios'
import { set } from '@/utils/vuex'
import userService from '@/services/userService'
import loggingService from '@/services/util/loggingService'

let isDebug = false

const state = {
    idToken: null,
    authenticated: false,
    authResult: null,
    spillsUserDto: null,
    profile: null
}

const getters = {
    authenticated: state => {
        return state.authenticated
    },
    spillsUserDto: state => {
        return state.spillsUserDto
    }
}

const mutations = {
    setIdToken: set('idToken'),
    setAuthenticated: set('authenticated'),
    setAuthResult: set('authResult'),
    setSpillsUserDto: set('spillsUserDto'),
    setProfile: set('profile'),
    resetState (state) {
        Object.assign(state, {
            accessToken: null,
            authenticated: false,
            authResult: null,
            spillsUserDto: null,
            profile: null
        })
    }
}

const actions = {
    authenticated ({ dispatch, commit }, authResult) {
        //loggingService.log(isDebug, 'auth', 'auth.authenticated - ' + state.authenticated)
        if (authResult) {
            commit('setAuthResult', authResult)
            commit('setIdToken', authResult.idToken)
            commit('setProfile', authResult.idTokenPayload)
            commit('setAuthenticated', true)
        }
        return new Promise((resolve, reject) => {
            var userPromise = userService.getCurrentSpillsUserDto(axios).then(response => {
                loggingService.log(isDebug, 'auth', 'auth.userService.getCurrentSpillsUserDto')
                commit('setSpillsUserDto', response.data)
            }, err => {
                reject(err)
            })

            Promise.all([userPromise]).then(results => {
                loggingService.log(isDebug, 'auth', 'authenticated - post promises')
                resolve(results)
            }, err => {
                reject(err)
            })
            resolve(1)
        })
    },
    logout ({ commit }) {
        commit('resetState', 'auth')
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
